import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};


class EngagementAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            EngagementId: null,
            Name: null,
            Description: null,
            Activity_Id: null,
            Impressions: null,
            Shows: null,
            Likes: null,
            Shares: null,
            Comments: null,
            Reposts: null,
            Saves: null,
            Clicks: null,
            Discussions: null,
            MeasureTime: null,
            Modifier: null,
            StartTime: null,
            EndTime: null,
            activity: (Object.keys(props.lookupLists.activity).map((d) => ({ value: d, label: props.lookupLists.activity[d] })) || []),
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            EngagementId: null,
            Name: null,
            Description: null,
            Activity_Id: null,
            Impressions: null,
            Shows: null,
            Likes: null,
            Shares: null,
            Comments: null,
            Reposts: null,
            Saves: null,
            Clicks: null,
            Discussions: null,
            MeasureTime: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            EngagementId: 1,
            Name: this.state.Name,
            Description: this.state.Description,
            Activity_Id: this.state.Activity_Id,
            Impressions: this.state.Impressions,
            Shows: this.state.Shows,
            Likes: this.state.Likes,
            Shares: this.state.Shares,
            Comments: this.state.Comments,
            Reposts: this.state.Reposts,
            Saves: this.state.Saves,
            Clicks: this.state.Clicks,
            Discussions: this.state.Discussions,
            MeasureTime: this.state.MeasureTime,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, activity } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Engagement.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Engagement.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Activity_Id')}
                                options={activity}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Engagement.Columns[3]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Impressions}
                            onChange={this.handleChange('Impressions')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Shows}
                            onChange={this.handleChange('Shows')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Likes}
                            onChange={this.handleChange('Likes')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Shares}
                            onChange={this.handleChange('Shares')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.Comments}
                            onChange={this.handleChange('Comments')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.Reposts}
                            onChange={this.handleChange('Reposts')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.Saves}
                            onChange={this.handleChange('Saves')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.Clicks}
                            onChange={this.handleChange('Clicks')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[12]}
                            type="text"
                            fullWidth
                            value={this.state.Discussions}
                            onChange={this.handleChange('Discussions')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Engagement.Columns[13]}
                            type="text"
                            fullWidth
                            value={this.state.MeasureTime}
                            onChange={this.handleChange('MeasureTime')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "EngagementAdd" })(EngagementAdd);
